import React from 'react'
import Row from 'react-bootstrap/Row'
import Container from 'react-bootstrap/Container'
import Col from 'react-bootstrap/Col'
import { NavBar } from './Navbar'
import { Buttons } from './Buttons'
import { ChartComponent } from './ChartComponent'
import { Subscribe } from './Subscribe'
import { BottomPart } from './BottomPart'
import { Footer } from './Footer'
import mobileLogo from '../assets/email-logo_white.png'
import greenDot from '../assets/greendot.png'
import Api from '../utils/Api'
import data from '../utils/data.json'
import bgBottom from '../assets/bg_bottom.svg'
import { Link, animateScroll } from 'react-scroll'

export class MainPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      trendDir: 'up',
      category: { value: 'All', label: 'All' },
      categories: [],
      charts: {}
    }

    this.subscribe = null
    this.api = new Api()
  }

  async componentDidMount() {
    const chartData = JSON.parse(JSON.stringify(data))
    
    let categories = ['All']
    let up = {}
    let down = {}
    let charts = {}

    up['All'] = {}
    down['All'] = {}


    chartData.forEach(chart => {
      const name = chart.name
      
      if (chart.growth_category === 'UP') {
        chart.categories.forEach(cat => {

          if (cat !== '') {
            if (!categories.includes(cat)) {
              categories.push(cat)
            }

            if (!up['All'].hasOwnProperty(name)) {
              up['All'][name] = chart
            }

            if (up.hasOwnProperty(cat)) {
              up[cat][name] = chart
            } else {
              up[cat] = {}
              up[cat][name] = chart
            }
          }

        })
      } else if (chart.growth_category === 'DOWN') {
        chart.categories.forEach(cat => {

          if (cat !== '') {
            if (!categories.includes(cat)) {
              categories.push(cat)
            }

            if (!down['All'].hasOwnProperty(name)) {
              down['All'][name] = chart
            }

            if (down.hasOwnProperty(cat)) {
              down[cat][name] = chart
            } else {
              down[cat] = {}
              down[cat][name] = chart
            }
          }
        })
      }
    })

    charts['up'] = up
    charts['down'] = down

    this.setState({ charts, categories })    
  }

  render() {
    const { charts, trendDir, category } = this.state
    let filteredCharts = []

    filteredCharts = (Object.keys(charts).length > 0 && charts[trendDir][category.value] !== undefined) ? [ ...Object.values(charts[trendDir][category.value]) ] : []
    
    const sortedCharts = filteredCharts.sort((a, b) => (a.rank < b.rank) ? -1 : 1)
        
    return (
      <>
      <NavBar />
      <Container style={{marginTop: 100}}>
        {/* <Row className='logo-row'>
          <Col xs={12} sm={6}>
            <a href='https://meetglimpse.com/'>
              <img src={mobileLogo} className='top-logo' alt='glimpse' />
            </a>
          </Col>
          <Col>
            <Link to='subscribe' smooth={true} offset={-200} duration={10}>
              <div className='updated-div'>
                <img src={greenDot} className='green-dot' style={{width: 9, height: 9}} />
                <span className='updated'>Get alerts</span>
              </div>
            </Link>
          </Col>
        </Row> */}
        <Col>
          <Row className='title-row'>
            <Col>
              <h1 className='title'>COVID-19 consumer impact tracker</h1>
              <p className='subtitle'>
                Glimpse tracks every topic across the internet.
                <br/>
                Here are the non-obvious trends impacted by Coronavirus.
              </p>
            </Col>
          </Row>
        </Col>
        <Buttons
          trendDir={this.state.trendDir}
          changeDir={(dir) => this.setState({ trendDir: dir })}
          category={this.state.category}
          changeCategory={(selectedOption) => this.setState({ category: selectedOption })}
          categories={this.state.categories}
        />
        {
          sortedCharts.length > 0 ?
          <Row style={{marginBottom: 40, marginLeft: -30, marginRight: -30}} className='chart-row'>
            {
              sortedCharts.map((chartData, i) => {
                const randomKey = Math.floor(Math.random() * (1000000 - 1 + 1) + 1)
                return <ChartComponent key={'chart-' + randomKey} id={randomKey} data={chartData} />
              })
            }
          </Row>
          :
          <Row style={{marginBottom: 40, marginLeft: -30, marginRight: -30, color: '#e1e9ff', fontFamily: "Inter", fontWeight:'bold', fontSize: '1.1rem', textAlign: 'center', display: 'block' }}>No trends matched this filter. Try something else instead!</Row>
        }
        
      </Container>
      <div style={{ backgroundImage: `url(${bgBottom})` }} className='bgBottom' name='subscribe'>
        <Container>
          <Subscribe />
        </Container>
      </div>
      <div className='bg-color'>
        <Container>
          <BottomPart />
          <Footer />
        </Container>
      </div>
      </>
    )
  }
} 
